import React, {  } from 'react';

import { relativeTimeFormatOptionsWithNumberingSystem } from '../types';
import { IntlFunction } from './Intl.Function';

export const IntlRelativeTimeFormatResolvedOptions = () => (
	<IntlFunction
		input={[]}
		mdnLink="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/RelativeTimeFormat/resolvedOptions"
		header="Intl.RelativeTimeFormat.prototype.resolvedOptions"
		description="Returns a new object with properties reflecting the locale and relative time formatting options computed during initialization of this [Intl.RelativeTimeFormat](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/RelativeTimeFormat) object."
		options={relativeTimeFormatOptionsWithNumberingSystem}
		ruleSet={[]}
		template="new Intl.RelativeTimeFormat(##locale##, ##options##).resolvedOptions()" />
)